import type { TrainerTag } from "../api";

export const TRAINER_TAGS: TrainerTag[] = ["Trainer", "Master Trainer"];

export const TRAINER_TAG_OPTIONS = TRAINER_TAGS.map((value) => ({
  value,
  label: value,
}));

export const TRAINER_TAG_BADGE_STYLES: Record<TrainerTag, string> = {
  Trainer: "bg-slate-100 text-slate-700",
  "Master Trainer": "bg-purple-100 text-purple-700",
};
